<template>
  <div class="address-search">
    <div v-if="!selectedAddress">
      <div class="title-bar">
        {{ $t.get('Sjekk om du også kan få raskt og stabilt bredbånd på din adresse') }}
      </div>

      <div class="search-container">
        <div class="search-spinner" v-if="searching">
          <i class="fa fas fa-spin fa-spinner"></i>
        </div>
        <input type="text" v-model="query" class="form-control" id="address-search-term"
          :placeholder="$t.get('Skriv inn din adresse her')" 
          v-on:keyup="onQueryChange()"/>
        <button :class="{'has-results': results && (results.length > 0 || query.length > 0) && !hasError()}">{{ $t.get('Sjekk') }}</button>
      </div>
      <div class="address-choices" v-if="results && (results.length > 0 || query.length >= 3) && !hasError() && !searching">
        <ul>
          <li v-for="(rec, index) of results" :key="'result-' + index" v-on:click.prevent="selectAddress(rec)" class="result">
            {{ rec.address }}
          </li>
          <li v-if="showNoAddressFoundMessage" class="no-address">
            <span>{{ $t.get('Vi finner ikke adressen.') }}<br/> {{ $t.get('Sjekk stavingen og prøv igjen. Hvis du fortsatt ikke får treff, send oss en melding ved å trykke her, så sjekker vi manuelt.') }}</span>
          </li>
        </ul>
      </div>
    </div>

    <StatusMessage ref="status" v-if="!selectedAddress" />
    <div class="small text-center cannotfind" v-if="!selectedAddress">
      <a href="javascript:;" v-on:click.prevent="redirectToContact()">{{ $t.get("Dersom du ikke har en gateadresse, så ta kontakt med oss via våre nettsider eller ring 69 70 18 00 (man-fre 8-16)") }}</a>
    </div>

    <div v-if="selectedAddress" class="selected-address">
      <div class="search-container address">
        <div class="form-control">{{ selectedAddress.address }}</div>
        <button v-on:click.prevent="deselectAddress()"><i class="fa fas fa-times"></i></button>
      </div>

      <ProductChooser :addressId="selectedAddress.id" :service-type="serviceType" :session="session"/>
    </div>

  </div>
</template>

<style scoped>
.address-search {
  /* color: #000; */
  max-width: 800px;
  margin: auto;
}
.address-search .title-bar {
  text-align: center;
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 18px;
}
.address-search .search-container {
  position: relative;
  text-align: center;
}

.address-search .search-container button {
  background: #000;
  color: #fff;
  border: 1px solid #000;
  font-weight: bold;
  font-size: 1.25rem;
  padding: 8px 16px;
  margin-top: 12px;
  margin-bottom: 12px;
}
.address-search .form-control {
  padding: 14px 16px;
  border: 1px solid #000;
  border-radius: 0px;
  font-size: 1.05rem;
  height: auto;
  box-shadow: 8px 8px 16px #000;
}
.address-choices {
  text-align: left;
  width: 100%; max-width: 800px;
  overflow-y: auto;
  background: #fff;
  box-sizing: border-box;
  padding: 8px;
  color: #000;
  position: relative;
  z-index: 2;
  border: 1px solid #000;
  border-top: 0px;
}
.address-choices ul {
  list-style: none;
  padding: 0px;
  font-size: 16px;
}
.address-choices ul li.result:hover {
  cursor: pointer;
  background: #444;
  color: #fff;
  transition: all 0.25s;
}
.address-search .no-address {
  height: 72px; display: flex; align-items: center;
  text-align: center;
  padding-left: 20px; padding-right: 20px;
  line-height: 20px;
}
.address-search .cannotfind {
  margin-top: 22px;
}
.address-search .cannotfind a {
  color: #fff;
}
.address-search .search-spinner {
  position: absolute;
  right: 10px; top: 10px;
  font-size: 1.5rem;
  color: #ff8000;
}
.address-search .has-results {
  display: none;
}

.selected-address {
  text-align: left;
}
.selected-address .address {
  margin-bottom: 22px;
}
.selected-address .address .form-control {
  background: #ccc;
}

@media (min-width: 576px) {
  .address-search .search-container {
    display: flex;
    box-shadow: 8px 8px 16px #000;
  }
  .address-search .form-control {
    padding: 8px 16px;
    box-shadow: none;
    font-size: 1.5rem;
  }
  .address-search .search-container button {
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 1.5rem;
  }
  .address-search .search-spinner {
    right: 108px;
  }
  
  .address-search .no-address {
    line-height: inherit;
  }

  .address-search .has-results {
    display: block;
  }

  .address-choices ul {
    font-size: inherit;
  }

}
</style>

<script>
/* global Urls $ */

import StatusMessage from '@/components/StatusMessage.vue'
import ProductChooser from '@/components/ProductChooser.vue'

export default {
  components: {
    StatusMessage,
    ProductChooser
  },
  props: ['serviceType', 'session', 'defaultAddressId'],
  data() {
    return {
      query: '',
      lastQuery: null,
      results: [],
      selectedAddress: null,
      searching: false,
      ts: null,
      showNoAddressFoundMessage: false
    }
  },
  mounted() {
    // setTimeout(() => {
    //   // this.query = 'Violgata 3A';
    //   // this.onQueryChange();
    //   this.selectedAddress = {
    //     "id": "339193d7-e9c6-4f1b-83b5-fff28d339553",
    //     "address": "Violgata 3A, HALDEN, 1776"
    //   };
    // }, 100);
    setTimeout(() => {
      if (this.defaultAddressId) {
        this.setAddressById(this.defaultAddressId);
      }
    }, 10)
  },
  methods: {
    setAddressById(id) {
      this.$refs.status.clear();
      this.searching = true;

      this.ts = new Date().getTime();
      this.$ajax.post(Urls.order_address_search(), {
        id: id,
        session: this.session
      }, true).then((res) => {
        this.searching = false;
        if (res.results.length === 0) {
          this.$refs.status.error(this.$t.get('Det oppsto en feil i bestillingssystemet. Vent et øyeblikk og klikk her for å prøve igjen.'), () => {
            this.setAddressById(id);
          });
        }
        this.selectedAddress = res.results[0];
      }).catch((err) => {
        this.searching = false;
        console.error(err);
      });

    },
    onQueryChange() {
      this.showNoAddressFoundMessage = false;
      if (!this.query || this.query.length < 3) {
        this.results = [];
        return;
      }
      if (this.query === this.lastQuery) {
        return;
      }

      this.lastQuery = this.query;

      this.$refs.status.clear();
      this.searching = true;

      this.ts = new Date().getTime();
      this.$ajax.post(Urls.order_address_search(), {
        q: this.query,
        ts: this.ts,
        session: this.session
      }, true).then((res) => {
        if (parseInt(res.ts) !== this.ts) {
          console.log('Ignoring stale result...');
          return;
        }
        this.results = res.results;
        this.showNoAddressFoundMessage = res.results.length === 0;
        this.searching = false;
      }).catch((err) => {
        this.searching = false;
        console.error(err);
        // NOTE: monsternett.no specific behaviour
        if ($ !== undefined && $('.broadband').length > 0) {
          this.$refs.status.error(this.$t.get('Det oppsto en feil i bestillingssystemet.') + '<br/>' + this.$t.get('Vent et øyeblikk og last siden på nytt for å prøve igjen. Hvis problemet fortsetter, så klikk her for å kontakte oss.'), () => {
            this.redirectToContact();
          });
        } else {
          this.$refs.status.error(this.$t.get('Det oppsto en feil i bestillingssystemet'));
        }
      });
    },
    hasError() {
      if (this.$refs.status && this.$refs.status.messageType) {
        return this.$refs.status.messageType === 'danger';
      }
      return false;
    },
    showDefaultProducts() {
      // TODO: This is monsternett.no specific behaviour.
      // Perhaps we could adapt this to use the new layout.
      $('.pricing-col').show();
      $('.ordering-app-container').hide();
    },
    redirectToContact() {
      // TODO: This is also monsternett.no specific behaviour.
      window.location.href = Urls.kundeservice();
    },
    selectAddress(address) {
      this.selectedAddress = address;
    },
    deselectAddress() {
      this.selectedAddress = null;
    }
  }
}
</script>
